import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TEvaluationReview {
  reviewId: number;
  reviewResult: string;
  errorLog: string;
  reviewType: number;
  reviewTypeName: string;
  reviewTypeDescription: string;
}

export interface IEvaluationReview extends TEvaluationReview {}

const EvaluationReview = Model(
  (model: TEvaluationReview): IEvaluationReview => {
    const _evaluationReview: TEvaluationReview = Object.assign({}, model);

    let create = (evaluationReview: IEvaluationReview): IEvaluationReview => {
      let obj = ValidatableObject(evaluationReview);
      return obj;
    };

    let evaluationReview = {
      get reviewId() {
        return _evaluationReview.reviewId;
      },
      set reviewId(value) {
        _evaluationReview.reviewId = value;
      },
      get reviewResult() {
        return _evaluationReview.reviewResult;
      },
      set reviewResult(value) {
        _evaluationReview.reviewResult = value;
      },
      get errorLog() {
        return _evaluationReview.errorLog;
      },
      set errorLog(value) {
        _evaluationReview.errorLog = value;
      },
      get reviewType() {
        return _evaluationReview.reviewType;
      },
      set reviewType(value) {
        _evaluationReview.reviewType = value;
      },
      get reviewTypeName() {
        return _evaluationReview.reviewTypeName;
      },
      set reviewTypeName(value) {
        _evaluationReview.reviewTypeName = value;
      },
      get reviewTypeDescription() {
        return _evaluationReview.reviewTypeDescription;
      },
      set reviewTypeDescription(value) {
        _evaluationReview.reviewTypeDescription = value;
      }
    };
    return create(evaluationReview);
  }
);

export default EvaluationReview;
